// extracted by mini-css-extract-plugin
module.exports = {"items":"index_items_2GKL-","item":"index_item_2rjPC"};